import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';
import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';

import { useUser } from '@work4all/data';
import { useSetting } from '@work4all/data/lib/settings/use-setting';

import { settings } from '../../../../../../../../settings';

export const PositionsSection = () => {
  const user = useUser();
  const { t } = useTranslation();
  const showMarkPositionsAsDoneCheckbox = useSetting(
    settings.projectTimeTrackingShowMarkPositionsAsDoneCheckbox()
  );

  return (
    <Collapse title={t('SETTINGS.PROJECT_TIME.POSITIONS')} defaultOpen>
      <CheckboxRadioItem
        control="checkbox"
        disabled={!user.isMaster}
        checked={showMarkPositionsAsDoneCheckbox.value}
        onChange={() =>
          showMarkPositionsAsDoneCheckbox.set(
            !showMarkPositionsAsDoneCheckbox.value
          )
        }
        label={t('SETTINGS.PROJECT_TIME.MARK_POSITIONS_AS_DONE')}
      />
    </Collapse>
  );
};
